import {
    Directive,
    EventEmitter,
    HostListener,
    OnDestroy,
    Output
} from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
    selector: '[tmDraggable]'
})
export class DraggableDirective implements OnDestroy {
    private _destroyed$: Subject<any> = new Subject<any>();

    @Output() public started = new EventEmitter();
    @Output() public completed = new EventEmitter();

    @HostListener('mousedown', ['$event']) public onMouseDown = (event: any) =>
        this.started.emit(event);

    @HostListener('touchstart', ['$event']) public onTouchStart = (
        event: any
    ) => this.started.emit(event);
    @HostListener('touchend', ['$event']) public onTouchEnd = (event: any) =>
        this.completed.emit(event);
    @HostListener('touchcancel', ['$event']) public onTouchCancel = (
        event: any
    ) => this.completed.emit(event);

    public ngOnDestroy() {
        this._destroyed$.next(true);
    }
}
